/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MarketRouteImport } from './routes/market'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ApprovalsRouteImport } from './routes/approvals'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StrategiesIndexRouteImport } from './routes/strategies/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as StrategiesIdRouteImport } from './routes/strategies/$id'
import { Route as SettingsTossRouteImport } from './routes/settings/toss'
import { Route as SettingsToolsRouteImport } from './routes/settings/tools'
import { Route as SettingsPushRouteImport } from './routes/settings/push'
import { Route as SettingsGeneralRouteImport } from './routes/settings/general'
import { Route as SettingsAiRouteImport } from './routes/settings/ai'
import { Route as ChatSessionIdRouteImport } from './routes/chat/$sessionId'
import { Route as StrategiesIdRunsIndexRouteImport } from './routes/strategies/$id.runs.index'
import { Route as StrategiesIdRunsRunIdRouteImport } from './routes/strategies/$id.runs.$runId'

const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketRoute = MarketRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategiesIndexRoute = StrategiesIndexRouteImport.update({
  id: '/strategies/',
  path: '/strategies/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategiesIdRoute = StrategiesIdRouteImport.update({
  id: '/strategies/$id',
  path: '/strategies/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTossRoute = SettingsTossRouteImport.update({
  id: '/settings/toss',
  path: '/settings/toss',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsToolsRoute = SettingsToolsRouteImport.update({
  id: '/settings/tools',
  path: '/settings/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPushRoute = SettingsPushRouteImport.update({
  id: '/settings/push',
  path: '/settings/push',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatSessionIdRoute = ChatSessionIdRouteImport.update({
  id: '/chat/$sessionId',
  path: '/chat/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const StrategiesIdRunsIndexRoute = StrategiesIdRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => StrategiesIdRoute,
} as any)
const StrategiesIdRunsRunIdRoute = StrategiesIdRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => StrategiesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approvals': typeof ApprovalsRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRoute
  '/portfolio': typeof PortfolioRoute
  '/chat/$sessionId': typeof ChatSessionIdRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/push': typeof SettingsPushRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/toss': typeof SettingsTossRoute
  '/strategies/$id': typeof StrategiesIdRouteWithChildren
  '/chat/': typeof ChatIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/strategies/': typeof StrategiesIndexRoute
  '/strategies/$id/runs/$runId': typeof StrategiesIdRunsRunIdRoute
  '/strategies/$id/runs/': typeof StrategiesIdRunsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approvals': typeof ApprovalsRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRoute
  '/portfolio': typeof PortfolioRoute
  '/chat/$sessionId': typeof ChatSessionIdRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/push': typeof SettingsPushRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/toss': typeof SettingsTossRoute
  '/strategies/$id': typeof StrategiesIdRouteWithChildren
  '/chat': typeof ChatIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/strategies': typeof StrategiesIndexRoute
  '/strategies/$id/runs/$runId': typeof StrategiesIdRunsRunIdRoute
  '/strategies/$id/runs': typeof StrategiesIdRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/approvals': typeof ApprovalsRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/notifications': typeof NotificationsRoute
  '/orders': typeof OrdersRoute
  '/portfolio': typeof PortfolioRoute
  '/chat/$sessionId': typeof ChatSessionIdRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/push': typeof SettingsPushRoute
  '/settings/tools': typeof SettingsToolsRoute
  '/settings/toss': typeof SettingsTossRoute
  '/strategies/$id': typeof StrategiesIdRouteWithChildren
  '/chat/': typeof ChatIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/strategies/': typeof StrategiesIndexRoute
  '/strategies/$id/runs/$runId': typeof StrategiesIdRunsRunIdRoute
  '/strategies/$id/runs/': typeof StrategiesIdRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approvals'
    | '/login'
    | '/market'
    | '/notifications'
    | '/orders'
    | '/portfolio'
    | '/chat/$sessionId'
    | '/settings/ai'
    | '/settings/general'
    | '/settings/push'
    | '/settings/tools'
    | '/settings/toss'
    | '/strategies/$id'
    | '/chat/'
    | '/settings/'
    | '/strategies/'
    | '/strategies/$id/runs/$runId'
    | '/strategies/$id/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approvals'
    | '/login'
    | '/market'
    | '/notifications'
    | '/orders'
    | '/portfolio'
    | '/chat/$sessionId'
    | '/settings/ai'
    | '/settings/general'
    | '/settings/push'
    | '/settings/tools'
    | '/settings/toss'
    | '/strategies/$id'
    | '/chat'
    | '/settings'
    | '/strategies'
    | '/strategies/$id/runs/$runId'
    | '/strategies/$id/runs'
  id:
    | '__root__'
    | '/'
    | '/approvals'
    | '/login'
    | '/market'
    | '/notifications'
    | '/orders'
    | '/portfolio'
    | '/chat/$sessionId'
    | '/settings/ai'
    | '/settings/general'
    | '/settings/push'
    | '/settings/tools'
    | '/settings/toss'
    | '/strategies/$id'
    | '/chat/'
    | '/settings/'
    | '/strategies/'
    | '/strategies/$id/runs/$runId'
    | '/strategies/$id/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApprovalsRoute: typeof ApprovalsRoute
  LoginRoute: typeof LoginRoute
  MarketRoute: typeof MarketRoute
  NotificationsRoute: typeof NotificationsRoute
  OrdersRoute: typeof OrdersRoute
  PortfolioRoute: typeof PortfolioRoute
  ChatSessionIdRoute: typeof ChatSessionIdRoute
  SettingsAiRoute: typeof SettingsAiRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsPushRoute: typeof SettingsPushRoute
  SettingsToolsRoute: typeof SettingsToolsRoute
  SettingsTossRoute: typeof SettingsTossRoute
  StrategiesIdRoute: typeof StrategiesIdRouteWithChildren
  ChatIndexRoute: typeof ChatIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StrategiesIndexRoute: typeof StrategiesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market': {
      id: '/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof MarketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategies/': {
      id: '/strategies/'
      path: '/strategies'
      fullPath: '/strategies/'
      preLoaderRoute: typeof StrategiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategies/$id': {
      id: '/strategies/$id'
      path: '/strategies/$id'
      fullPath: '/strategies/$id'
      preLoaderRoute: typeof StrategiesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/toss': {
      id: '/settings/toss'
      path: '/settings/toss'
      fullPath: '/settings/toss'
      preLoaderRoute: typeof SettingsTossRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tools': {
      id: '/settings/tools'
      path: '/settings/tools'
      fullPath: '/settings/tools'
      preLoaderRoute: typeof SettingsToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/push': {
      id: '/settings/push'
      path: '/settings/push'
      fullPath: '/settings/push'
      preLoaderRoute: typeof SettingsPushRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ai': {
      id: '/settings/ai'
      path: '/settings/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof SettingsAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$sessionId': {
      id: '/chat/$sessionId'
      path: '/chat/$sessionId'
      fullPath: '/chat/$sessionId'
      preLoaderRoute: typeof ChatSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/strategies/$id/runs/': {
      id: '/strategies/$id/runs/'
      path: '/runs'
      fullPath: '/strategies/$id/runs/'
      preLoaderRoute: typeof StrategiesIdRunsIndexRouteImport
      parentRoute: typeof StrategiesIdRoute
    }
    '/strategies/$id/runs/$runId': {
      id: '/strategies/$id/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/strategies/$id/runs/$runId'
      preLoaderRoute: typeof StrategiesIdRunsRunIdRouteImport
      parentRoute: typeof StrategiesIdRoute
    }
  }
}

interface StrategiesIdRouteChildren {
  StrategiesIdRunsRunIdRoute: typeof StrategiesIdRunsRunIdRoute
  StrategiesIdRunsIndexRoute: typeof StrategiesIdRunsIndexRoute
}

const StrategiesIdRouteChildren: StrategiesIdRouteChildren = {
  StrategiesIdRunsRunIdRoute: StrategiesIdRunsRunIdRoute,
  StrategiesIdRunsIndexRoute: StrategiesIdRunsIndexRoute,
}

const StrategiesIdRouteWithChildren = StrategiesIdRoute._addFileChildren(
  StrategiesIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApprovalsRoute: ApprovalsRoute,
  LoginRoute: LoginRoute,
  MarketRoute: MarketRoute,
  NotificationsRoute: NotificationsRoute,
  OrdersRoute: OrdersRoute,
  PortfolioRoute: PortfolioRoute,
  ChatSessionIdRoute: ChatSessionIdRoute,
  SettingsAiRoute: SettingsAiRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsPushRoute: SettingsPushRoute,
  SettingsToolsRoute: SettingsToolsRoute,
  SettingsTossRoute: SettingsTossRoute,
  StrategiesIdRoute: StrategiesIdRouteWithChildren,
  ChatIndexRoute: ChatIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StrategiesIndexRoute: StrategiesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
